<template>
  <div>
    <el-dialog class="dialog" :visible.sync="dialogVisible" :width="isMobile" :close-on-click-modal='false'>
       <el-form :model="params" :rules="rules" ref="ruleForm">
        <h2>写字楼信息</h2>
        <el-form-item label="城市" prop="city">
          <el-input v-model="params.city" placeholder="（必填）请输入所在城市"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="params.address" placeholder="（必填）请填写详细的区、街道、编号"></el-input>
        </el-form-item>
        <el-form-item label="占地面积" prop="area">
          <el-input v-model="params.area" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="（必填）请填写占地面积"></el-input>
        </el-form-item>
        <el-form-item label="房间数量" prop="roomNum">
          <el-input v-model="params.roomNum" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="（必填）请填写房间数量"></el-input>
        </el-form-item>
        <h2>联系方式</h2>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="params.phone" placeholder="（必填）请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="如何称呼" prop="name">
          <el-input v-model="params.name" placeholder="（必填）请输入联系人姓名"></el-input>
        </el-form-item>
        <h2>备注及其他信息</h2>
        <el-form-item label-width="0" prop="remark">
          <el-input v-model="params.remark" type="textarea" placeholder="请输入备注或其他信息"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" class @click="submit">提交</el-button>
    </el-dialog>
    <div class="fixed">
      <div class="mobile">
        <img
          class="img"
          src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/kfdh@2x.png"
          alt
        />
        <div class="hoverPhone">
          <img
            class="back"
            src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/second/khzxbk@2x.png"
            alt
          />
          <div class="text">
            <p>客户咨询</p>
            <p class="orange">4000-989-222</p>
          </div>
        </div>
      </div>
      <div class="btn" @click="dialogVisible=true">立即委托</div>
      <div class="code">
        <img
          src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/erweima@2x.png"
          alt
        />
        <div class="codeHover">
          <img class="back" src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/erweimak@2x.png" alt="">
          <div class="text">
            <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/gongzh@2x.png" alt="">
            <p>微信服务号</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { trustSubmit } from '@/api/common.js'
export default {
  name: "",
  components: {},
  data() {
    return {
      rules:{
        city: [
          { required: true, message: '请输入城市名称', trigger: 'blur' },
        ],
        address:[
          {required: true, message: '请输入地址', trigger: 'blur'}
        ],
        area:[
          {required: true, message: '请输入面积数值', trigger: 'blur'}
        ],
        roomNum:[
          {required: true, message: '请输入房间数量', trigger: 'blur'}
        ],
        phone:[
          {required: true, message: '请输入联系人号码', trigger: 'blur'},
          {
            pattern: /^1[1-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur"
          }
        ],
        name:[
          {required: true, message: '请输入联系人姓名', trigger: 'blur'}
        ],
      },
      params: {
        city: "",
        address: "",
        area: "",
        roomNum: "",
        phone: "",
        name: "",
        remark: ""
      },
      dialogVisible: false
    };
  },
  methods: {
    init() {},
    submit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let data=Object.assign({},this.params);
          trustSubmit(data).then(res=>{
            if(res.status==0){
              this.$message.success('委托已提交')
              this.dialogVisible=false
            }else{
              this.$message.error(res.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    }
  },
  computed: {
    isMobile() {
      console.log(this.$store.getters.scale, "大小");
      if (this.$store.getters.scale > 480) {
        return "30%";
      } else {
        return "90%";
      }
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang='less' scoped>
@import "~style/index";
.dialog {
  /deep/ .el-button--primary {
    color: #ffffff;
    background: #fd7e25;
    border-color: #fd7e25;
    width: 50%;
    position: relative;
    transform: translateX(-50%);
    left: 50%;
  }
}
.fixed {
  z-index: 999;
  position: fixed;
  right: 0;
  top: 50%;
  width: 42px;
  display: flex;
  align-items: center;
  flex-direction: column;
  .mobile {
    cursor: pointer;
    width: 100%;
    position: relative;
    .img {
      width: 100%;
      display: block;
    }
    &:hover .hoverPhone {
      display: block;
    }
    .hoverPhone {
      position: absolute;
      left: 0;
      top: 0;
      transform: translateX(-100%);
      display: none;
      .back {
        max-width: 200px;
        object-fit: contain;
      }
      .text {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        p:first-child {
          color: white;
        }
      }
    }
  }
  .btn {
    text-align: center;
    padding: 8px 4px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 24px;
    background: #333333;
    cursor: pointer;
  }
  .btn:hover{
    color:rgba(255, 122, 50, 1)
  }
  .code {
    position: relative;
    text-align: center;
    padding: 15px 0;
    width: 100%;
    background: #fff;
    cursor: pointer;
    >img {
      width: 22px;
    }
    &:hover .codeHover {
      display: block;
    }
    .codeHover{
      position: absolute;
      left: 10px;
      top: -60%;
      transform: translateX(-100%);
      display: none;
      .back{
        max-width: 240px;
        object-fit: contain;
      }
      .text {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        img{
          max-width: 122px;
        }
        p {
          color: white;
        }
      }
    }
  }
}
</style>